import { ButtonLink } from "@/components/ui/button";
import { ColumnList } from "@/components/ui/column-list";
import { Pill } from "@/components/ui/pill";
import { EmptyState, QueryState } from "@/components/ui/states";
import { useConnectors } from "@/features/connectors/hooks";
import type { NewExperiment } from "./use-new-experiment";

export function StepConnection({ flow }: { flow: NewExperiment }) {
  const connectors = useConnectors();
  const label = (type: string) => connectors.data?.find((c) => c.type === type)?.label ?? type;
  const list = flow.agentConnections;
  return (
    <QueryState query={flow.connections} what="connections">
      {list.length === 0 ? (
        <EmptyState
          title="No connections yet"
          action={<ButtonLink to="/settings/connections?add=1">Add a connection</ButtonLink>}
        >
          An admin adds a connection once: a platform, its base URL and how the workbench signs in.
        </EmptyState>
      ) : (
        <ColumnList
          title="Connection"
          name="connection"
          items={list.map((c) => ({
            value: c.id,
            label: c.name,
            note: `${label(c.connector_type)} · ${c.base_url}`,
            extra: c.last_check_error ? <Pill tone="err">Check failed</Pill> : undefined,
          }))}
          value={flow.connection?.id ?? null}
          onChange={flow.pickConnection}
        />
      )}
    </QueryState>
  );
}
